module.exports = __webpack_public_path__ + "img/CommerceCare-Healthcare-Logo.d45030f9.svg";